export enum AgentsRoutes {
  AgentsList = 'agents-list',
  AgentManagement = 'agent-management',
  AgentsIssues = 'agents-issues',
}
